import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import StreetMarketCard from 'src/components/reports/reportsBoard/CommercialsReports/StreetMarketCard'
import MarketStreeTransportCard from 'src/components/reports/reportsBoard/CommercialsReports/MarketStreeTransportCard'
import SreetMarketWorkCard from 'src/components/reports/reportsBoard/CommercialsReports/SreetMarketWorkCard'
import StreetMarketDeportCard from 'src/components/reports/reportsBoard/CommercialsReports/StreetMarketDeportCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const StreetMarketPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()
  return (
    <>
      <CardTitle
        title="Mercado Motos Enduro"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <StreetMarketCard {...props} />
      <MarketStreeTransportCard {...props} />
      <SreetMarketWorkCard {...props} />
      <StreetMarketDeportCard {...props} />
    </>
  )
}

export default StreetMarketPage
